import React, { useEffect, useState } from "react";
import { Minus, Plus, ShoppingBag } from "lucide-react";
import { Dialog, DialogContent, DialogTitle } from "../ui/dialog";
import { useStore } from "../../pages/market/StoreShell";
import { money } from "../../lib/marketApi";

export const ProductSheet = ({ product: p, onClose }) => {
  const { store, addToCart } = useStore();
  const [img, setImg] = useState(0);
  const [qty, setQty] = useState(1);
  useEffect(() => {
    setImg(0);
    setQty(1);
  }, [p]);
  if (!p) return null;
  const add = () => {
    addToCart(p.id, qty);
    onClose();
  };
  return (
    <Dialog open={!!p} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-h-[92vh] max-w-3xl overflow-y-auto rounded-3xl p-0" style={{ background: "var(--mk-surface)", color: "var(--mk-text)" }} data-testid="product-sheet">
        <div className="grid md:grid-cols-2">
          <div className="bg-slate-100">
            <div className="aspect-square">{p.images[img] && <img src={p.images[img]} alt={p.name} className="h-full w-full object-cover" />}</div>
            {p.images.length > 1 && (
              <div className="flex gap-2 overflow-x-auto p-2">
                {p.images.map((u, i) => (
                  <button key={u + i} onClick={() => setImg(i)} className={`h-14 w-14 shrink-0 overflow-hidden rounded-lg border-2 ${i === img ? "border-[var(--mk-primary)]" : "border-transparent"}`}>
                    <img src={u} alt="" className="h-full w-full object-cover" />
                  </button>
                ))}
              </div>
            )}
          </div>
          <div className="flex flex-col gap-3 p-6">
            {p.category && <p className="text-xs font-semibold uppercase tracking-wider" style={{ color: "var(--mk-primary)" }}>{p.category}</p>}
            <DialogTitle className="text-2xl font-bold leading-tight">{p.name}</DialogTitle>
            <div className="flex items-baseline gap-2">
              <span className="text-2xl font-extrabold">{money(p.price, store.currency)}</span>
              {p.compare_at > p.price && <span className="text-sm line-through opacity-50">{money(p.compare_at, store.currency)}</span>}
            </div>
            <p className="whitespace-pre-line text-sm opacity-75">{p.description}</p>
            <p className="text-xs opacity-60">{p.stock > 0 ? `${p.stock} disponibles` : "Agotado"}</p>
            <div className="mt-auto flex items-center gap-3 pt-4">
              <div className="flex items-center rounded-full border border-black/10">
                <button onClick={() => setQty((q) => Math.max(1, q - 1))} className="p-3" data-testid="product-qty-minus"><Minus className="h-4 w-4" /></button>
                <span className="w-6 text-center text-sm font-semibold" data-testid="product-qty">{qty}</span>
                <button onClick={() => setQty((q) => Math.min(p.stock, q + 1))} className="p-3" data-testid="product-qty-plus"><Plus className="h-4 w-4" /></button>
              </div>
              <button
                disabled={p.stock <= 0}
                onClick={add}
                className="flex flex-1 items-center justify-center gap-2 rounded-full py-3.5 text-sm font-semibold text-white shadow-lg transition-transform active:scale-95 disabled:opacity-40"
                style={{ background: "var(--mk-primary)", color: "var(--mk-on-primary)" }}
                data-testid="product-sheet-add"
              >
                <ShoppingBag className="h-4 w-4" /> Agregar al carrito
              </button>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
